import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Reusable lead/booking form. type = bookings | enrollments | bridal | leads
// extraFields: [{ name, placeholder, type, options, required }]
export const LeadForm = ({ type = "leads", extraFields = [], title, sub, cta = "Submit", testid = "lead-form" }) => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/${type}`, form);
      toast.success("Thank you! Our team will reach out to you shortly.");
      setForm({});
      e.target.reset();
    } catch {
      toast.error("Something went wrong. Please call +91 9916161865.");
    } finally { setLoading(false); }
  };

  const field = (f) => {
    const common = { key: f.name, required: f.required, className: "card-input", onChange: set(f.name),
      "data-testid": `${testid}-${f.name}`, value: form[f.name] || "" };
    if (f.type === "select") {
      return (
        <select {...common} defaultValue="">
          <option value="" disabled className="bg-midnight">{f.placeholder}</option>
          {f.options.map((o) => <option key={o} value={o} className="bg-midnight">{o}</option>)}
        </select>
      );
    }
    return <input {...common} placeholder={f.placeholder} type={f.type || "text"} />;
  };

  return (
    <form onSubmit={submit} data-testid={testid} className="glass rounded-xl p-8 sm:p-10 space-y-6">
      {title && <div><h3 className="text-2xl sm:text-3xl">{title}</h3>{sub && <p className="text-white/60 mt-2 text-sm">{sub}</p>}</div>}
      <div className="grid sm:grid-cols-2 gap-6">
        <input required placeholder="Full Name" className="card-input" onChange={set("name")} value={form.name || ""} data-testid={`${testid}-name`} />
        <input required placeholder="Phone" className="card-input" onChange={set("phone")} value={form.phone || ""} data-testid={`${testid}-phone`} />
        <input required type="email" placeholder="Email" className="card-input sm:col-span-2" onChange={set("email")} value={form.email || ""} data-testid={`${testid}-email`} />
        {extraFields.map(field)}
      </div>
      <textarea placeholder="Message (optional)" rows={2} className="card-input" onChange={set("message")} value={form.message || ""} data-testid={`${testid}-message`} />
      <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-60" data-testid={`${testid}-submit`}>
        {loading ? "Sending…" : cta}
      </button>
    </form>
  );
};
